var Features;
(function (Features) {
    Features["TOKEN"] = "TOKEN";
    Features["ACCOUNT_LINK"] = "ACCOUNT_LINK";
    Features["CURRENTLANG"] = "CURRENTLANG";
    Features["TRANSLATION"] = "TRANSLATION";
    Features["SOCKET"] = "SOCKET";
})(Features || (Features = {}));
export default Features;
